export { default } from './RedirectToIdentityRequirementOrDashboard.container';
